export default __webpack_public_path__ + "static/outstretched-hand-88f3b376ee5ed515262b2f11b542411b.jpg";